/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'add': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M25 25v100h100V25H25zm50 19.316c.664 0 1.969.535 1.969 1.2V73.03h27.516c.664.004 1.199 1.305 1.199 1.969 0 .664-.535 1.969-1.2 1.969H76.97v27.516c0 .664-1.305 1.199-1.969 1.199-.664 0-1.969-.535-1.969-1.2V76.97H45.515c-.664-.004-1.199-1.305-1.199-1.969 0-.664.535-1.969 1.2-1.969H73.03V45.515c0-.664 1.305-1.199 1.969-1.199z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
